/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowOrderQueryResponse, GetShowOrderPathParams, GetShowOrderQueryParams, GetShowOrder401, GetShowOrder404 } from "../../models/GetShowOrder";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowOrderUrl({ salesOrderNumber }: { salesOrderNumber: GetShowOrderPathParams["salesOrderNumber"] }) {
  const res = { method: 'GET', url: `/api/v1/orders/${salesOrderNumber}` as const }  
  return res
}

/**
 * {@link /api/v1/orders/:salesOrderNumber}
 */
export async function getShowOrder({ salesOrderNumber, params }: { salesOrderNumber: GetShowOrderPathParams["salesOrderNumber"]; params: GetShowOrderQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowOrderQueryResponse, ResponseErrorConfig<GetShowOrder401 | GetShowOrder404>, unknown>({ method : "GET", url : getGetShowOrderUrl({ salesOrderNumber }).url.toString(), params, ... requestConfig })  
  return res.data
}